import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.r3z_1 = sink;
        this.s3z_1 = false;
        this.t3z_1 = new (Buffer())();
      }
      i3v(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.t3z_1.i3v(source, byteCount);
        this.u3z();
        return Unit_instance;
      }
      y3y(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.t3z_1.y3y(byteString);
        return this.u3z();
      }
      a3z(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.t3z_1.a3z(string);
        return this.u3z();
      }
      b3z(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.t3z_1.b3z(string, beginIndex, endIndex);
        return this.u3z();
      }
      c3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.t3z_1.c3z(b);
        return this.u3z();
      }
      u3z() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.t3z_1.j3y();
        if (byteCount > 0n) {
          this.r3z_1.i3v(this.t3z_1, byteCount);
        }
        return this;
      }
      qc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.s3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.t3z_1.k3v_1 > 0n) {
          this.r3z_1.i3v(this.t3z_1, this.t3z_1.k3v_1);
        }
        this.r3z_1.qc();
        return Unit_instance;
      }
      q6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.s3z_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.t3z_1.k3v_1 > 0n) {
              this.r3z_1.i3v(this.t3z_1, this.t3z_1.k3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.r3z_1.q6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.s3z_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.r3z_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
